import type { AxiosResponse } from 'axios';

/**
 * Payload of the backend's `return_class` body: `res.data.data.data`.
 *
 * Strict: `undefined` when absent, never the metadata row. Older per-carrier
 * copies (e.g. `unwrapFedExSuccessPayload`) fall back to the envelope.
 */
export function unwrapEnvelopePayload<T extends object>(
  res: AxiosResponse<unknown>
): T | undefined {
  const body = res?.data as Record<string, unknown> | undefined;
  const envelope = body?.data as Record<string, unknown> | undefined;
  const nested = envelope?.data;
  return nested && typeof nested === 'object' ? (nested as T) : undefined;
}
